import React, { Fragment } from "react";
import Dashboard from "../Common/Components/Dashboard";
import Sidebar from "../Common/Components/Sidebar";
import RunningPeriodsWidget from "./RunningPeriodsWidget"
import RunningPeriodChartOptions from "./RunningPeriodChartOptions";
import Filters from "../Devices/Filter";
import DashboardOptions from "../Common/Components/DashboardOptions";

const RunningPeriodsIndex = () => {

    const positionData = 
    [{ col: 1, colSpan: 6, rowSpan: 6 }];

    const sidebarItems = [
        {title: "Chart Options", item:<RunningPeriodChartOptions id="2"/>,expanded:true},
        {title: "Filters", item:<Filters id="1" deviceWithSerialInput="required" groupByInput={true} devicesFromMultipleCustomers={true}/>,expanded:true},
        {title: "Dashboard Options", item: < DashboardOptions />, expanded: true }
    ]

    return (
        <Fragment>
            <Dashboard positionData={positionData} sidebarItems={sidebarItems}>
                <RunningPeriodsWidget id="2" header ="Running Period Categories" />
            </Dashboard>
        </Fragment>
    )
}

export default RunningPeriodsIndex;